import { render, staticRenderFns } from "./VtFooter.vue?vue&type=template&id=964ac4b2&"
import script from "./VtFooter.vue?vue&type=script&lang=js&"
export * from "./VtFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports